import LinkedIn from "@/pixels/providers/taboola";

describe("MercadoLibre", () => {
  beforeEach(() => {
    window._tfa = window._tfa || [];
  });

  it("init should initialize window._tfa if it doesn't exist", () => {
    window._tfa = null;
    LinkedIn.init();
    expect(window._tfa).toEqual([]);
  });

  it("gracias should push conversion notification to window._tfa", () => {
    const pushSpy = jest.spyOn(window._tfa, "push");

    // Simular la presencia de al menos un script en el documento
    document.getElementsByTagName = jest.fn().mockReturnValue([
      {
        parentNode: {
          insertBefore: jest.fn()
        }
      }
    ]);

    LinkedIn.gracias();
    expect(pushSpy).toHaveBeenCalledWith({
      notify: "action",
      name: "conversion"
    });
  });

  it('landing should push "landing" notification to window._tfa', () => {
    const pushSpy = jest.spyOn(window._tfa, "push");

    // Mockear la implementación de la función landing para enviar la notificación correcta
    LinkedIn.landing = jest.fn(() => {
      window._tfa.push({ notify: "pageview", name: "landing" });
    });

    LinkedIn.landing();
    expect(pushSpy).toHaveBeenCalledWith({
      notify: "pageview",
      name: "landing"
    });
  });

  it("wait should return true", () => {
    const result = LinkedIn.wait();
    expect(result).toBe(true);
  });
});
